import styled, { css } from "styled-components";

interface JoinFormStyleProps {
  $formButton?: boolean;
  $gridColumn?: string;
  $alignItems?: "flex-start" | "center";
  $textAlign?: "left" | "center";
  $gap?: string;
}

export const JoinForm = styled.form<JoinFormStyleProps>`
  display: grid;
  width: 100vw;
  height: auto;
  min-height: 100%;
  align-items: center;
  justify-content: center;
  grid-template-rows: ${(props) =>
    props.$formButton === true ? "auto 92px" : "1fr"};
  background: ${(props) => props.theme.colors.introBg};
  font-family: "Pretendard";

  // 모바일 환경(600px 이하) 설정
  @media (max-width: 600px) {
    display: grid;
    /* grid-template-rows: ${(props) =>
      props.$formButton === true ? "1fr 95px" : "1fr"}; */
    overflow-y: auto;
    height: 100%;
    align-items: flex-start;
  }

  // 모바일 가로 모드 대응
  @media (max-height: 500px) and (orientation: landscape) {
    display: flex;
    flex-direction: column;
    gap: 20px;
    overflow-y: auto;
    // height: calc(100vh - 56px);
    height: auto;
    align-items: stretch;
  }

  // 태블릿 환경 (768px 이상, 세로) 설정
  @media (min-width: 768px) and (orientation: portrait) {
    align-items: start;
  }

  // 태블릿 환경 (1000px 이상, 가로) 설정
  @media (min-width: 1000px) and (orientation: landscape) {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

export const FormBox = styled.div<JoinFormStyleProps>`
  overflow-y: hidden;
  display: flex;
  height: ${(props) =>
    props.$formButton === true ? "calc(100vh - 172px)" : "calc(100vh - 80px)"};
  padding: 16px;
  align-items: ${(props) => (props.$alignItems ? "flex-start" : "center")};
  flex-direction: column;
  gap: 50px;

  // 모바일 환경(600px 이하) 설정
  @media (max-width: 600px) {
    height: ${(props) =>
      props.$formButton === true
        ? "calc(100vh - 190px)"
        : "calc(100vh - 56px)"};
    padding: 16px;
    gap: ${(props) => props.$gap};
    position: relative;
  }

  // 모바일 가로 모드 대응
  @media (orientation: landscape) {
    flex: 1;
    width: 100%;
    height: auto;
    overflow: hidden;
    gap: 20px;
    padding: 16px;
  }

  // 태블릿 환경 (768px 이상, 세로) 설정
  @media (min-width: 768px) and (orientation: portrait) {
    height: auto;
    overflow-y: auto;
    gap: 30px;
  }

  // 태블릿 환경 (1000px 이상, 가로) 설정
  @media (min-width: 768px) and (orientation: landscape) {
    min-width: 800px;
    gap: 30px;
  }
`;

export const FormTitBox = styled.div<JoinFormStyleProps>`
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 16px;
  font-family: "Pretendard";

  // 모바일 환경(600px 이하) 설정
  @media (max-width: 600px) {
    gap: 10px;
  }

  // 모바일 가로 모드 대응
  @media (orientation: landscape) {
    gap: 10px;
  }
`;

export const PageIndicator = styled.div`
  font-size: 1.6rem;
  margin-bottom: 10px;
  display: flex;
  justify-content: flex-start;

  // 태블릿 환경(768px 이상) 설정
  @media (min-width: 768px) {
    font-size: 2.2rem;
  }
`;

export const PageIndex = styled.span`
  font-weight: 600;
  color: #18181899;
`;

export const PageTotal = styled.span`
  font-weight: 400;
  color: #18181833;
`;

export const FormTit = styled.h3`
  font-size: 2.8rem;
  font-weight: 800;

  // 모바일 환경(600px 이하) 설정
  @media (max-width: 600px) {
    font-size: 2.2rem;
  }
`;

export const FormSubTit = styled.h4`
  font-size: 1.8rem;
  font-weight: 600;
  line-height: 140%;

  // 모바일 가로 모드 대응
  @media (orientation: landscape) {
    font-size: 2.2rem;
  }

  // 태블릿 환경(768px 이상) 설정
  @media (min-width: 768px) {
    font-size: 2.6rem;
  }
`;

export const FormTxt = styled.p<JoinFormStyleProps>`
  color: ${(props) => props.theme.colors.black38};
  font-size: 1.6rem;
  text-align: ${(props) => (props.$textAlign ? "left" : "center")};
  line-height: 140%;

  // 모바일 환경(600px 이하) 설정
  @media (max-width: 600px) {
    font-size: 1.4rem;
  }
`;

export const FormContent = styled.div<JoinFormStyleProps>`
  overflow-y: auto;
  display: ${(props) => (props.$gridColumn ? "grid" : "flex")};
  width: 75vw;
  height: auto;
  align-items: center;
  justify-content: center;
  gap: 20px;

  ${(props) =>
    props.$gridColumn &&
    css`
      grid-template-columns: ${props.$gridColumn};
    `}

  // 모바일 환경(600px 이하) 설정
  @media (max-width: 600px ) {
    overflow-y: auto;
    display: flex;
    width: calc(100vw - 32px);
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;
    gap: 35px;

    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background: ${(props) => props.theme.colors.scrollbar};
      border: 1px solid ${(props) => props.theme.colors.white38};
      border-radius: 2px;
    }
  }

  // 모바일 가로 모드 대응
  @media (orientation: landscape) {
    flex: 1;
    width: 100%;
    height: auto;
    overflow: auto;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }

  // 태블릿 환경 (768px 이상, 세로) 설정
  @media (min-width: 768px) and (orientation: portrait) {
    display: flex;
  }
`;

export const FormBottom = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const FormInfoTxt = styled.p`
  font-size: 1.3rem;
  font-weight: 500;
  color: ${(props) => props.theme.colors.black40};
  text-align: center;

  // 태블릿 환경(768px 이상) 설정
  @media (min-width: 768px) {
    font-size: 1.6rem;
  }
`;

export const FormButtonBox = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;
